import { Report198Container } from "../../../containers/borrowSystem/Report/Report198Container";

export function Report198Page() {
    return (
        <Report198Container />
    )
}